import React from 'react'
import { Container, Row, Col, Button, Card, Nav } from 'react-bootstrap'
import logo from './geraniumposlogo.jpg'
// import { LinkContainer } from 'react-router-bootstrap'

const Home = () => {
  return (
    <Container fluid='md' className='bg-secondary'>
      <Row>
        <Col>
          <Card bg='white' className='my-2 p-2 rounded' border='primary'>
            <Card.Header>
              <h4>Our Software</h4>
            </Card.Header>
            <Card.Body>
              <Card.Text>
                GeraniumPoS is software as a service (SaaS) that allows you to
                maintain and track your inventory as a sole propietor or small
                business owner.
                <br />
                <br></br>
                Additionally there is an optional point of sale (POS) system
                that allows you to sell your products and services to your
                customers. You can send electronic receipts to the client in
                their GeraniumReceipt wallet.
                <br />
                <br></br>
                It is a simple and easy to use solution that will help you
                manage your inventory with an optional Point of Sale. We want to
                help you succeed.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              For information:{' '}
              <a href='mailto:info@hermanosgazpachos.ca'>
                Click to send an email.
              </a>
              {' | '}
              <a
                href='https://geraniumreceipt.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                Visit GeraniumReceipt.com
              </a>
            </Card.Footer>
          </Card>
        </Col>
        <Col>
          <br />
          <img
            src={logo}
            alt='GeraniumPoS logo'
            style={{
              width: '100%',
              height: '85%',
              maxWidth: '350px',
              display: 'block',
              margin: '0 auto'
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Nav>
            <Nav.Link href='/login'>
              <Button className='btn btn-light'>Login</Button>
            </Nav.Link>
            <Nav.Link href='/owner'>
              <Button className='btn btn-outline'>
                Register Your Business
              </Button>
            </Nav.Link>
          </Nav>
        </Col>
      </Row>
    </Container>
  )
}

export default Home
